// Firebase initialization for the Forgemark portal.
//
// These config values are PUBLIC by design — they identify the project, not
// authorize it. Security is enforced by Firebase Authentication and Firestore
// security rules, never by hiding this block. It is safe to commit.
//
// >>> Paste the firebaseConfig block from the Firebase console here:
//     Project settings (gear) > Your apps > Web app > SDK setup > Config.
//     Replace every REPLACE_ME below with the real value.
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCZZh2TazYYap_m_7Ewc-PSYV1pkb8s5xU',
  authDomain: 'forgemark-d53ae.firebaseapp.com',
  projectId: 'forgemark-d53ae',
  storageBucket: 'forgemark-d53ae.firebasestorage.app',
  messagingSenderId: '164733782361',
  appId: '1:164733782361:web:aef9be1a4f47249e7b6448',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
